export const PreConferenceInterval = 30;